import React, { useState } from 'react';
import './styles.css';


import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarPlus } from 'react-icons/fa';




export default function WidgetFilterMonth() {

  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  const handleDateSelect = (e: any) => {
    console.log("handleDateSelect", e);
    setSelectedDate(e);
  }

  const handleDateChange = (e: Date) => {
    console.log("handleDateChange", e.getMonth(), e.getFullYear());
    setSelectedDate(e);
  }

  return (

    <div id='widget-filter'>
      <div className="d-flex align-items-center position-relative w-100">
        <DatePicker
          className="date-picker"
          selected={selectedDate}
          onSelect={(e: any) => handleDateSelect(e)}
          onChange={(e: any) => handleDateChange(e)}
          dateFormat="MMM/yyyy"
          locale="pt"
        />
        <FaRegCalendarPlus className="position-absolute calendar"></FaRegCalendarPlus>
      </div>
      <button className='btn btn-secundary'>Adicionar parceiro</button>
    </div>

  )
}
